import Marquee from "react-fast-marquee";

const WORDS = ["PHOTO", "VIDEO", "GRAPHIC DESIGN", "COPYWRITING", "SOCIAL MEDIA", "WEB DESIGN"];

// Slim connective band on the dark page background.
export const ServicesMarquee = () => (
  <div
    className="flex items-center border-y border-[var(--hair)] overflow-hidden bg-[var(--dark)] py-[26px]"
    data-testid="services-marquee"
  >
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w) => (
        <span
          key={w}
          className="font-display text-[24px] uppercase text-white mx-6 flex items-center gap-6"
        >
          {w}
          <span className="text-[var(--red)] text-[18px]">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default ServicesMarquee;
